import { DefaultState, Filters } from 'store/types';

export const SET_USERS_TABLE_FILTERS = 'SET_USERS_TABLE_FILTERS';

export type GetUsersTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetUsersTableFilters {
  type: typeof SET_USERS_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type GetUsersTableFiltersActionTypes = SetUsersTableFilters;
